export function activateTabs() {
  var guardSymbol = '__biglobe__tagsShortcodeHasAlreadyBeenInitialized__',
    head,
    style

  if (window[guardSymbol]) {
    return
  }
  window[guardSymbol] = true

  document.querySelectorAll('.tabs').forEach(function(el) {
    var tabList = el.querySelectorAll('.tabs__tab'),
      content = el.querySelector('.tabs__content'),
      activeClass = 'tabs__tab--active',
      unnecessaryParagraph,
      i

    function onClick(nth) {
      return function(event) {
        var i

        event.preventDefault()
        if (this.classList.contains(activeClass)) {
          return
        }

        for (i = 0; i < tabList.length; i++) {
          tabList[i].classList.remove(activeClass)
        }

        activateNthTab(nth)
      }
    }

    function activateNthTab(i) {
      var targetTab = tabList[i],
        templates = el.getElementsByTagName('script'),
        targetTemplate = templates.item(i)

      targetTab.classList.add(activeClass)

      if (targetTemplate) {
        content.innerHTML = targetTemplate.textContent
        // WordPressによって<p>が自動挿入されていたらそれを取り除く
        if (
          content.firstChild &&
          content.firstChild.tagName === 'P' &&
          content.lastChild &&
          content.lastChild.tagName === 'P'
        ) {
          content.removeChild(content.firstChild)
          content.removeChild(content.lastChild)
        }
      }
    }

    for (i = 0; i < tabList.length; i++) {
      // WordPressによって<p>が自動挿入されていたら、それを取り除く
      if (tabList[i].parentNode.tagName === 'P') {
        unnecessaryParagraph = tabList[i].parentNode
        unnecessaryParagraph.parentNode.insertBefore(
          unnecessaryParagraph.querySelector('script[type="text/x-template"]'),
          unnecessaryParagraph.nextSibling
        ) // <script>を<p>の後ろへ移動
        unnecessaryParagraph.parentNode.replaceChild(
          tabList[i],
          unnecessaryParagraph
        ) // <p>とtabList[i]を入れ替え
      }
      tabList[i].addEventListener('click', onClick(i))
    }

    if (tabList.length) {
      activateNthTab(0)
    }
  })
}
